<template>
    <div>
        <ul class="radio-container">
            <li v-for="option in question.options.items" :class="{'selected': option.id == value }" v-bind:key="option.id">
                <label>
                    <input type="radio" @change="update_done_status" :name="question.id" :value="option.id" v-model="value" :checked="!!question.value" /><span>{{ option.label }}</span>
                </label>
            </li>
        </ul>
    </div>
</template>

<script>
  export default {
    name: 'RadioControl',
    props: ['question', 'callback'],
    data: function(){
      return {
        'value': this.$props.question.value ? this.$props.question.value : null
      }
    },
    methods: {
      'update_done_status': function () {
        this.$props.question.value = this.$data.value;
        this.$emit('answered', {
          'status': this.$props.question.value !== undefined && this.$props.question.value !== null,
          'id': this.$props.question.id,
          'value': this.$props.question.value,
        });
      }
    }
  }
</script>

<style scoped>
</style>
